import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, Facet, ProductSearchPage, User, WindowRef } from '@spartacus/core';
import {
  BREAKPOINT,
  BreakpointService,
  FacetListComponent,
  FacetService,
  ICON_TYPE,
  ProductListComponentService,
} from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { fadeIn, fadeOut } from '../../../../../../../custom/animation/custom-animations';

@Component({
  selector: 'cx-facet-list',
  templateUrl: './custom-facet-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeIn, fadeOut],
  standalone: false
})
export class CustomFacetListComponent extends FacetListComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  selected = null;
  isVisible = false;
  showFacets = false;
  professional = false;
  consumer = true;
  category: string;
  user$: Observable<User | undefined> = this.userAccount.get();
  model$: Observable<ProductSearchPage> = this.productListComponentService
    .model$;
  iconTypes = ICON_TYPE;
  clearFilters = false;
  isMobile = false;
  toggleSortingFilters = false;

  toggleGroup(event: UIEvent): void {
    this.isVisible = !this.isVisible;
  }

  toggleSelected(i): void {
    this.selected = i;
    this.cd.markForCheck();
  }

  isSelected(facet: Facet): boolean {
    return facet.values.some((value) => value.selected);
  }

  showAllFacets(): void {
    this.showFacets = !this.showFacets;
    this.toggleSortingFilters = !this.showFacets;
    if (this.showFacets) {
      this.toggleSortingFilters = false;
    }
    this.removeModalClass();
  }

  sortList(sortCode: string): void {
    this.productListComponentService.sort(sortCode);
  }


  constructor(
    protected facetService: FacetService,
    protected elementRef: ElementRef<HTMLElement>,
    protected renderer: Renderer2,
    private userAccount: UserAccountFacade,
    private auth: AuthService,
    private productListComponentService: ProductListComponentService,
    protected route: ActivatedRoute,
    protected cd: ChangeDetectorRef,
    protected breakpointService: BreakpointService,
    protected winRef: WindowRef
  ) {
    super(facetService, elementRef, renderer);
    this.subscriptions.add(this.route.paramMap.subscribe(params => {
      this.category = params.get('categoryCode');
    }));
    this.subscriptions.add(this.user$.subscribe(user => {
      this.professional = user?.professional || false;
      this.consumer = user?.consumer || true;
    }));
  }

  ngOnInit(): void {
    this.subscriptions.add(this.route.queryParams
      .subscribe(params => {
        if (params?.query && params.query.length) {
          const paramsArray = params.query.split(':');
          this.clearFilters = paramsArray?.length > 1;
        } else {
          this.clearFilters = false;
        }
      }));
    this.subscriptions.add(this.breakpointService.isDown(BREAKPOINT.md).subscribe(isMobile => {
      this.isMobile = isMobile;
      this.cd.markForCheck();
      this.removeModalClass();
    }));
  }

  removeModalClass(): void {
    if (this.isMobile) {
      if (this.showFacets) {
        this.renderer.addClass(this.winRef.document.body, 'modal-open');
      } else {
        this.renderer.removeClass(this.winRef.document.body, 'modal-open');
      }
    } else {
      this.renderer.removeClass(this.winRef.document.body, 'modal-open');
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
